import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { ButtonItem, SegmentedItem, TableItemDinamico, NotificacionMovimientosInventario } from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { connect } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";

moment.locale('es')

class Comodato extends Component {
  tableRef = React.createRef();
  state = {
    todasComodato: [],
    loading: false,
    valor: 5,
    totalRecords: 0,
  }

  async consultarComodato(params) {
    this.setState({ loading: true })
    await axios
      .post(
        "comodato/selectOrdenes",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasComodato: res.data.ordenes,
            loading: false,
            totalRecords: res.data.totalRecords || 0,
          });
        } else {
          this.setState({ todasComodato: [], loading: false });
        }
      });
  }
  agregarOrdenComodato() {
    this.props.history.push('/panel/agregarOrdenComodato')
  }
  importarComodato() {
    this.props.history.push('/panel/importarComodato')
  }
  recibirInsumosComodato(id) {
    this.props.history.push('/panel/recibirInsumosComodato', { id })
  }
  cancelarOrden(value) {
    axios
      .post(
        "comodato/cancelarOrden",
        { ordenComodatoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Orden cancelada");
          NotificacionMovimientosInventario(res.data.movimientosIds);
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Codigo",
        dataIndex: "codigoOrden",
        key: "codigoOrden",
        // sorter: (a, b) => {
        //   if (a.codigoOrden < b.codigoOrden) {
        //     return -1;
        //   }
        //   if (a.codigoOrden > b.codigoOrden) {
        //     return 1;
        //   }
        //   return 0;
        // },
        render: (value) => value,
        buscar: 'codigoOrden',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto < b.proyecto) {
            return -1;
          }
          if (a.proyecto > b.proyecto) {
            return 1;
          }
          return 0;
        },
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proveedor / Cliente",
        dataIndex: "clienteNombre",
        key: "clienteNombre",
        buscar: 'clienteNombre',
        width: '16%',
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaOrden",
        key: "fechaOrden",
        defaultSortOrder: 'descend',
        sorter: (a, b) => {
          if (moment(a.fechaOrden) < moment(b.fechaOrden)) {
            return -1;
          }
          if (moment(a.fechaOrden) > moment(b.fechaOrden)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('ll'),
        wdith: '12%',
        ellipsis: true,
        align: 'center',
      },
      ...(this.props.taxidermia ? [
        {
          title: "Insumos",
          dataIndex: "insumos",
          key: "insumos",
          render: (value) => {
            return (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                {value.map((insumo, index) => (
                  <Tooltip key={index.toString()} title={insumo.descripcionTooltip}>
                    <Tag className="square-tag" color={insumo.colorTag || 'blue'}>
                      {insumo.descripcionTag}
                    </Tag>
                  </Tooltip>
                ))}
              </div>
            );
          },
          width: '35%',
        },
      ] : []),
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        render: (value, record, index) => {
          if (value === 0) {
            return <Tag key={index.toString()} color='red' className="square-tag">Cancelada</Tag>
          }
          if (value === 1) {
            return <Tag key={index.toString()} color='blue' className="square-tag">Sin recibir</Tag>
          }
          if (value === 2) {
            return <Tag key={index.toString()} color='orange' className="square-tag" style={{ fontSize: 10 }}>Recibido parcialmente</Tag>
          }
          if (value === 3) {
            return <Tag key={index.toString()} color='green' className="square-tag">Recibido</Tag>
          }
        },
        width: '12%',
        ellipsis: true,
      },
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: "center",
        width: '10%',
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          if (value.estado === 0) return null

          let buttons = []

          if ((value.estado === 1 || value.estado === 2) && this.props.permisoRecibirInsumosComodato) {
            buttons.push(
             <Tooltip title="Descargar XML" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
             <ButtonItem blanco key={`recibir-${index}`} type='default' size='small' onClick={() => this.recibirInsumosComodato(value._id)}>Recibir Insumos</ButtonItem> </Tooltip>)
          }
          if (value.estado !== 0 && this.props.permisoCancelarComodato) {
            buttons.push(<Popconfirm
              title="Seguro que quieres cancelar esta orden?"
              onConfirm={() => this.cancelarOrden(value._id)}
              okText="Si"
              cancelText="No"
              key={`cancelar-${index}`}
            >
            <Tooltip title="Cancelar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                rojo
                icon={<CloseCircleOutlined />}
              >
              </ButtonItem>
            </Tooltip>
            </Popconfirm>)
          }

          if (value.faltaImagenes && this.props.taxidermia) {
            buttons.push(<Tag key={index.toString()} color='orange' className="square-tag">Imagenes</Tag>)
          }

          if (value.faltaArchivos && this.props.taxidermia) {
            buttons.push(<Tag key={index.toString()} color='orange' className="square-tag">Archivos</Tag>)
          }
          return <div className="acciones-container">{buttons}</div>
        },
      }
    ]
    return (
      <>
        <PageHeader
          title="Comodato"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[
                    // {label: 'Sin Recibir', value: 1}, 
                    // {label: 'Recibido Parcialmente', value: 2}, 
                    { label: 'Recibido', value: 3 },
                    { label: 'Cancelada', value: 4 },
                    { label: 'Todos', value: 5 }]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              {this.props.permisoAgregarOrdenComodato && this.props.taxidermia &&
                <ButtonItem
                  key="importarComodato"
                  onClick={this.importarComodato.bind(this)}
                  className="botonAgregar"
                >
                  Importar Excel
                </ButtonItem>}
              {this.props.permisoAgregarOrdenComodato &&
                <ButtonItem
                  type="primary"
                  key="agregarOrdenComodato"
                  olivo
                  onClick={this.agregarOrdenComodato.bind(this)}
                  className="botonAgregar"
                >
                  Agregar Orden
                </ButtonItem>}
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: event => {
                this.props.history.push('/panel/verOrdenComodato', { id: record._id })
              },
            };
          }}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarComodato.bind(this)}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasComodato}
          columns={columns}
          defaultPageSize={20}
          filterStorageKey={"comodatoFiltrosTablas" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={5}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} 
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
    permisoAgregarOrdenComodato: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a03f6ce92846884441258f9")?.activado,
    permisoCancelarComodato: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a03f6de92846884441258fa")?.activado,
    permisoRecibirInsumosComodato: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cc149f30e81b54183cf64")?.activado,
  };
};

export default connect(mapStateToProps)(Comodato);